<template>
  <div class="input-container zip-container">
    <input
      id="zip_code"
      v-model.lazy="$v.zipCode.$model"
      class="input input--zip"
      :class="{'input--error' : $v.zipCode.$invalid === true}"
      type="number"
      pattern="\d*"
      name="zip_code"
    >
    <span
      v-show="$v.zipCode.$invalid === true"
      class="has__error"
    >
      Invalid Zip Code
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      zipCode: ''
    }
  },
  watch: {
    '$v.zipCode.$invalid' (value) {
      this.$emit('valid', (value === false), this.$options._componentTag)
    }
  },
  created () {
    axios.get('//geoip.improvetool.com/json/')
      .then((response) => {
        this.zipCode = ((this.zipCode === '') ? response.data.zip_code : this.zipCode)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  validations: {
    zipCode: {
      required,
      isValidZip (val) {
        if (val === '') return true

        return axios.post('//' + process.env.VUE_APP_LINK + '/formApi.php?a=checkZip&zip_code=' + val)
          .then((response) => {
            if (response.data !== false) {
              this.$emit('input', val, response.data.city, response.data.state)
              return true
            } else {
              return false
            }
          })
          .catch((error) => {
            console.log(error)
            return false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .input-container {
    &.zip-container{
      width: 200px;
      margin: 0 auto;
    }
    .input {
     &.input--zip {
       width: 200px;
       font-size: 30px;
       text-align: center;
     }
    }
  }
</style>
